'use strict';

module.exports = [
  $contextMulti];

function $contextMulti() {

}


// WEBPACK FOOTER //
// ./src/js/core-components/context-menu/ContextMultiService.js